import {
  hasTaskDetailsFeature,
  splitBarcodeImages,
  TASK_DETAILS_FEATURES,
} from './slices/utils/taskDetailsFeatures';

//heimal
export function isLoadingSession({ session: { loading } }) {
  return loading;
}

export function userInfo({ session: { userInfo } }) {
  return userInfo;
}

export function hasSession({ session: { loggedIn } }) {
  return loggedIn;
}

//store
export function storesList({ stores: { stores } }) {
  return stores;
}

export function loadingStores({ stores: { loading } }) {
  return loading;
}

export function chainsList({ stores: { chains } }) {
  return chains;
}

export function storeNames({ stores: { storeNames } }) {
  return storeNames;
}

export function currentChain({ stores: { currentChain } }) {
  return currentChain;
}

export function currentStoreName({ stores: { currentStoreName } }) {
  return currentStoreName;
}

export function currentStore({ stores: { currentStore } }) {
  return currentStore;
}

export function currentStoreIndex({ stores: { currentStoreIndex } }) {
  return currentStoreIndex;
}

export function prevStoreNames({ stores: { prevStoreNames } }) {
  return prevStoreNames;
}

export function supplierIds({ stores: { supplierIds } }) {
  return supplierIds;
}

export function loadingSupplier({ stores: { loadingSupplier } }) {
  return loadingSupplier;
}

//categories
export function categoriesList({ categories: { categories } }) {
  return categories;
}

export function loadingCategories({ categories: { loading, listLoading } }) {
  return loading || listLoading;
}

export function currentCategory({ categories: { currentCategory } }) {
  return currentCategory;
}

export function currentCategoryKey({ categories: { currentKey } }) {
  return currentKey;
}

export function categoriesProgress({ categories: { progress } }) {
  return progress;
}

// tasks
export function tasksList({ tasks: { tasksList } }) {
  return tasksList;
}

export function tasksFilterList({ tasks: { tasksFilterList } }) {
  return tasksFilterList;
}

export function tasksFilterSearchList({ tasks: { tasksFilterSearchList } }) {
  return tasksFilterSearchList;
}

export function loadingTaskList({ tasks: { taskLoading } }) {
  return taskLoading;
}


export function progressLoadedStore({ tasks: { progressLoadedStore } }) {
  return progressLoadedStore;
}

export function loadingMoreTask({ tasks: { moreTasksLoading } }) {
  return moreTasksLoading;
}

export function progressTasksType({ tasks: { progressTasksType } }) {
  return progressTasksType;
}

export function progressTasksTypeBaseline({ tasks: { progressTasksTypeBaseline } }) {
  return progressTasksTypeBaseline;
}

export function resourcesTasksType({ tasks: { resourcesTasksType } }) {
  return resourcesTasksType;
}

export function resourcesReportOptions({ tasks: { resourcesReportOptions } }) {
  return resourcesReportOptions;
}

export function searchReportOptions({ search: { reportOptions } }) {
  return reportOptions;
}

export function searchReportOptionsLoading({ search: { reportOptionsLoading } }) {
  return reportOptionsLoading;
}

export function searchReportOptionsFetchedStore({ search: { reportOptionsFetchedStore } }) {
  return reportOptionsFetchedStore;
}

export function searchProductInfo({ products: { products, adjustment, placement } }) {
  if (Object.keys(products).length === 0) return null;
  return { ...products, adjustment, placement };
}

export function searchProductInfoLoading({ products: { loading, loading_captures } }) {
  return loading || loading_captures;
}

export function searchProductImages({ products: { captures } }) {
  return captures;
}

export function searchProductBarcodeUrl({ images: { barcode } }) {
  return barcode || null;
}

export function excelLoading({ excel: { loading } }) {
  return loading;
}

export function loadingProgress({ tasks: { progressLoading } }) {
  return progressLoading;
}

export function failedProgress({ tasks: { failedProgress } }) {
  return failedProgress;
}

// Narrowed by the active task filters. Only the task list may read this pair;
// anything that reports the whole store reads the baseline one below.
export function totalProgress({ tasks: { totalTasks } }) {
  return totalTasks;
}

export function pendingProgress({ tasks: { pendingTasks } }) {
  return pendingTasks;
}

// The baseline pair describes the whole store: it ignores the task-list filters
// so screens outside the task list keep reporting the same workload no matter
// what the user last filtered by. See progressTasksTypeBaseline.
export function totalProgressBaseline({ tasks: { totalTasksBaseline } }) {
  return totalTasksBaseline;
}

export function pendingProgressBaseline({ tasks: { pendingTasksBaseline } }) {
  return pendingTasksBaseline;
}

export function loadingTasksStatus({ tasks: { tasksStatusLoading } }) {
  return tasksStatusLoading;
}

export function tasksStatusList({ tasks: { tasksStatus } }) {
  return tasksStatus;
}

export function currentTaskType({ tasks: { currentTaskType } }) {
  return currentTaskType;
}

export function taskTypeIcons({ tasks: { icons } }) {
  return icons;
}

export function taskReportIcons({ tasks: { reportIcons } }) {
  return reportIcons;
}

// tasks modification
export function reportMessage({ tasksModification: { reportMessage } }) {
  return reportMessage;
}

export function loadingReport({ tasksModification: { loadingReport } }) {
  return loadingReport;
}

//Images
export function imagesList({ images: { images } }) {
  return images;
}

export function loadingImages({ images: { loading } }) {
  return loading;
}

export function barcodeLink({ images: { barcode } }) {
  return barcode;
}

//Aisles
export function aislesByTaskList({ aisles: { aislesByTasks } }) {
  return aislesByTasks;
}

export function aislesList({ aisles: { aisles } }) {
  return aisles;
}

export function aislesFilterList({ aisles: { aislesFilter } }) {
  return aislesFilter;
}

export function loadingAisles({ aisles: { loading } }) {
  return loading;
}

export function aislesLayout({ aisles: { layout } }) {
  return layout;
}

export function aisleClientNames({ aisles: { aisleClientNames } }) {
  return aisleClientNames;
}

export function aislesPendingTasks({ aisles: { aislesPendingTasks } }) {
  return aislesPendingTasks;
}

export function hasOverheadTasks({ resourcesOverhead: { hasOverhead } }) {
  return hasOverhead;
}

export function loadingOverhead({ resourcesOverhead: { loading } }) {
  return loading;
}

//task detail features
export function taskDetailsFeatures({ resourcesTaskDetailsFeatures: { features } }) {
  return features;
}

export function loadingTaskDetailsFeatures({
  resourcesTaskDetailsFeatures: { loading },
}) {
  return loading;
}

/**
 * Whether the barcode is promoted out of the carousel into its own control.
 * Membership test, never equality: the column is generic and future
 * affordances arrive as extra entries in the same list.
 */
export function hasBarcodeButton(state) {
  return hasTaskDetailsFeature(
    taskDetailsFeatures(state),
    TASK_DETAILS_FEATURES.BARCODE,
  );
}

/**
 * Images the task-detail carousel should show. Identical to `imagesList` when
 * the barcode feature is off. When it is on, the barcode is removed, which can
 * leave the list empty, and callers must then skip the carousel instead
 * of rendering an empty frame.
 */
export function taskCarouselImages(state) {
  return splitBarcodeImages(imagesList(state), hasBarcodeButton(state)).carouselImages;
}

/**
 * URL of the scannable barcode behind the button, or null when the feature is
 * off or this task type has no barcode asset at all.
 */
export function taskBarcodeUrl(state) {
  return splitBarcodeImages(imagesList(state), hasBarcodeButton(state)).barcodeUrl;
}

//filters
export function filters({ filters: { filters } }) {
  return filters;
}

export function filterList({ filters: { filterList } }) {
  return filterList;
}

export function supplierSelected({ filters: { supplierSelected } }) {
  return supplierSelected;
}

//snackbar
export function snackbarContent({ snackbar: { content } }) {
  return content;
}

export function snackbarVisible({ snackbar: { visible } }) {
  return visible;
}

export function snackbarColor({ snackbar: { color } }) {
  return color;
}

//floating button
export function floatingButtonVisible({
  floatingButton: { visible },
  users: { firstLogin },
}) {
  return visible && !firstLogin;
}

export function menuVisible({ floatingButton: { open } }) {
  return open;
}

//navigation
export function navigationStatus({ navigation: { finished } }) {
  return finished;
}

export function navigationLoading({ navigation: { loading } }) {
  return loading;
}

export function navigationFetched({ navigation: { fetched } }) {
  return fetched;
}

export function navigationCompleted({ navigation: { completed } }) {
  return completed;
}

export function navigationPending({ navigation: { pending } }) {
  return pending;
}

export function navigationLast({ navigation: { last } }) {
  return last;
}

export function navigationProgress({ navigation: { progress } }) {
  return progress;
}

export function navigationAccess({ navigation: { navigationAccess } }) {
  return navigationAccess;
}

//search
export function loadingSearch({ search: { loading } }) {
  return loading;
}

export function searchResults({ search: { results } }) {
  return results;
}

export function searchResultsFilter({ search: { resultsFilter } }) {
  return resultsFilter;
}

export function reportParameters({ search: { reportParameters } }) {
  return reportParameters;
}

export function scanerSelected({ search: { scanerSelected } }) {
  return scanerSelected;
}

//products
export function loadingProduct({ products: { loading } }) {
  return loading;
}

export function productsInformation({ products: { products } }) {
  return products;
}

export function adjustmentInformation({ products: { adjustment } }) {
  return adjustment;
}

export function placementInformation({ products: { placement } }) {
  return placement;
}

export function loadingCaptures({ products: { loading_captures } }) {
  return loading_captures;
}

export function lastCaptures({ products: { captures } }) {
  return captures;
}

export function emptyCaptures({ products: { emptyCaptures } }) {
  return emptyCaptures;
}

//user information
export function loadingUser({ users: { loading } }) {
  return loading;
}

export function usersFirstName({ users: { firstName } }) {
  return firstName;
}

export function usersFirstLogin({ users: { firstLogin } }) {
  return firstLogin;
}

export function usersLastName({ users: { lastName } }) {
  return lastName;
}

export function usersEmail({ users: { email } }) {
  return email;
}

export function usersUpdateMessage({ users: { updateMessage } }) {
  return updateMessage;
}

export function usersPasswordResponse({ users: { passwordResponse } }) {
  return passwordResponse;
}

export function usersPasswordRejected({ users: { passwordRejected } }) {
  return passwordRejected;
}

export function usersPasswordSuccess({ users: { passwordSuccess } }) {
  return passwordSuccess;
}

export function passwordLoading({ users: { is_password_loading } }) {
  return is_password_loading;
}

//tickets
export function ticketsList({ tickets: { tickets } }) {
  return tickets;
}

export function ticketsLoading({ tickets: { loading } }) {
  return loading;
}

export function ticketsCreateResponse({ tickets: { createMessage } }) {
  return createMessage;
}

export function ticketsCreateLoading({ tickets: { createLoading } }) {
  return createLoading;
}

//bot messages
export function botMessages({ botMessages: { botMessages } }) {
  return botMessages;
}

export function botMessagesLoading({ botMessages: { loading } }) {
  return loading;
}

//brands
export function brandDict({ brands: { brandDict } }) {
  return brandDict;
}

//views
export function viewsList({ views: { views } }) {
  return views;
}

export function loadingViews({ views: { loading } }) {
  return loading;
}
